// TODO move all string messages here


export const messages = {
    standardError : 'somethingWentWrong'
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/settings/messages.js